<template>
  <card-edit @edit="$emit('edit')">
    <order-contact :order="$store.getters.orderSystem.order" flat divider />
  </card-edit>
</template>

<script>
import CardEdit from "@/modules/delivery/components/CardEdit/CardEdit.vue";
import OrderContact from "@/modules/delivery/components/OrderContact/OrderContact.vue";

export default {
  name: "OrderReviewContact",
  components: {OrderContact, CardEdit},
}
</script>

<style scoped>

</style>
